export var IdentityProviderName;
(function (IdentityProviderName) {
    IdentityProviderName["Cognito"] = "Cognito";
    IdentityProviderName["Facebook"] = "Facebook";
    IdentityProviderName["Google"] = "Google";
    IdentityProviderName["Microsoft"] = "Microsoft";
    IdentityProviderName["Mock"] = "Mock";
})(IdentityProviderName || (IdentityProviderName = {}));
